import { CollectionsService } from './services/common/collections.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { PrimeNGConfig } from 'primeng/api';
import { GLOBAL_VARIABLES } from './shared/data/const.data';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'AMRCloud Admin';

  constructor(private auth: AuthService,
  private srv: CollectionsService,
  private prime: PrimeNGConfig
    ) { }

  ngOnInit() {

    // if (this.auth.isAuthenticated()) {
    //   if (this.auth.isExpired) {
    //     this.auth.logOut();
    //     this.srv.resetAll(false);

    //     console.log('token expired');
    //   } else {
    //     this.auth.check();
    //     this.srv.resetAll(this.auth.isAuthenticated());
    //     console.log('token sender');
    //   }
    // }

    this.prime.setTranslation(GLOBAL_VARIABLES.PRIMENG_RU);
    this.srv.resetAll(this.auth.isAuthenticated());

  }
}
